export default "__VITE_ASSET__f37646cb__"